import api from './api';
import { Invite, adaptInvite } from '../models/Invite';

export default class InviteService {
  static async createInvite(saveId: string, roleCode: string): Promise<string> {
    const { data } = await api.post(`/saves/${saveId}/invites`, { roleCode });
    return data.url || data.link || data.token;
  }

  static async getInvite(token: string): Promise<Invite> {
    const { data } = await api.get(`/invites/${token}`);
    return adaptInvite(data);
  }

  static async acceptInvite(token: string): Promise<any> {
    const { data } = await api.post(`/invites/${token}/accept`);
    return data;
  }
}
